import { toast } from "react-toastify"

import { useLazyChangeContractorsDevicesStatusQuery } from "store/api/contractorsApi"
import { ApiTypes } from "types"
import { ReactComponent as IconTransfer } from "assets/svg/modal-icon-trasfer.svg"

import getErrorMessage from "utils/getErrorMessage"
import ConfirmationModal from "modals/ConfirmationModal/ConfirmationModal"

interface InventoryConfirmationModalProps {
  selectedDevices: ApiTypes.Model.Device[]
  onCancel: () => void
  onSuccess: () => void
}

const InventoryConfirmationModal = ({ onCancel, selectedDevices, onSuccess }: InventoryConfirmationModalProps) => {
  const [triggerChangeContractorsDevicesStatus, { isFetching }] = useLazyChangeContractorsDevicesStatusQuery()

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      const res = await triggerChangeContractorsDevicesStatus({
        devices: selectedDevices.map(device => device.sn),
        new_status: "inventory",
      })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
      } else {
        toast.success("The status of the selected thermostat(s) was changed successfully!")
        onSuccess()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <ConfirmationModal
      title="In Inventory"
      message="Are you sure you want to change the status of the thermostat to In Inventory?"
      isFetching={isFetching}
      icon={<IconTransfer />}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  )
}

export default InventoryConfirmationModal
